import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type TotalSelector = (state: ReduxState) => number
const getTotal: TotalSelector = (state) => state.payPalSettings.pagination.total

export const totalSelector: TotalSelector = createSelector(getTotal, (total) => total)
